import React from "react";

interface ITitle {
  title: string;
  link: string;
}

const AppTitle: React.FC<ITitle> = ({ title, link }) => {
  return (
    <p className='text-center mt-3'>
      API from{" "}
      <a href={link} target='_blank' rel='noreferrer'>
        {link}
      </a>
      <br />
      {title}
    </p>
  );
};

export default AppTitle;
